import z from "zod";

import { pageSearchParam } from "@/core/hooks/use-list-search";

// every data tab shares the filters, which the /data layout route declares,
// while each tab route declares its own page so paging one tab leaves the
// others on their first page
export const dataResourceFiltersSearchSchema = z.object({
  search: z.string().optional(),
  user: z.email().optional(),
  at: z
    .enum(["today", "this-week", "this-month", "this-year", "all-time"])
    .optional(),
  type: z.enum(["vectorized", "table_data"]).optional(),
});

export const dataResourcePageSearchSchema = z.object({ page: pageSearchParam });

export const dataResourceListSearchSchema =
  dataResourceFiltersSearchSchema.extend(dataResourcePageSearchSchema.shape);

const datasourceSortSearchSchema = z.object({
  sort: z
    .enum(["name", "data_type", "uploaded_by", "updated_at"])
    .default("updated_at")
    .catch("updated_at"),
  dir: z.enum(["asc", "desc"]).default("desc").catch("desc"),
});

export const datasourcesTabSearchSchema = dataResourcePageSearchSchema.extend(
  datasourceSortSearchSchema.shape,
);

export const datasourcesListSearchSchema = dataResourceListSearchSchema.extend(
  datasourceSortSearchSchema.shape,
);

export const collectionsTabSearchSchema = dataResourcePageSearchSchema.extend({
  sort: z
    .enum(["name", "datasource_count", "created_at"])
    .default("created_at")
    .catch("created_at"),
  dir: z.enum(["asc", "desc"]).default("desc").catch("desc"),
});

export const collectionsListSearchSchema = dataResourceListSearchSchema.extend(
  collectionsTabSearchSchema.shape,
);
